import React from "react";
import { Button } from "@/modern/components/ui/button";
import { Upload, Loader2 } from "lucide-react";
import { usePublishPromptCards, PublishConfig } from "../hooks/usePublishContextCards";
import { InspectionType, AdvisorType, PromoteType } from "../constants/settingsStructure";

interface PublishButtonProps {
  inspectionType?: InspectionType;
  advisorType?: AdvisorType;
  promoteType?: PromoteType;
}

const PublishButton = ({ inspectionType, advisorType, promoteType }: PublishButtonProps) => {
  // Create config for publish hook
  const publishConfig: PublishConfig = promoteType
    ? { mode: 'promote', promoteType }
    : advisorType
      ? { mode: 'field-advisor', advisorType }
      : { mode: 'context', inspectionType: inspectionType || "site_safety" };

  const { hasDraftChanges, canPublish, handlePublish, isPublishing } = usePublishPromptCards(publishConfig);

  if (!hasDraftChanges) {
    return null;
  }

  const isDisabled = !canPublish;

  return (
    <div className="px-6 pt-6 pb-0">
      <div className="flex items-center justify-between p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
        <div className="flex-1">
          <h4 className="text-sm font-semibold text-blue-900 dark:text-blue-200 mb-1">Unpublished Changes</h4>
          <p className="text-sm text-blue-800 dark:text-blue-300">You have unpublished changes. Click publish to make them live.</p>
        </div>
        <Button onClick={handlePublish} disabled={isDisabled || isPublishing} size="sm" className="ml-4 flex-shrink-0">
          {isPublishing ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Upload className="h-4 w-4 mr-2" />}
          {isPublishing ? "Publishing..." : "Publish Changes"}
        </Button>
      </div>
    </div>
  );
};

export default PublishButton;
